import { styled } from '@mui/system';

import Button from 'ihp-components/components/v2/Button';

export const StyledFilledButton = styled(Button)({
  height: '50px',
  padding: '6px 30px',
  fontSize: '14px',
});
